(function() {

  angular
  .module('meanApp')
  .factory('usersManager', usersManager);

  usersManager.$inject = ['User', "modelManager", 'httpAuth', '$q'];
  function usersManager (User, modelManager, httpAuth, $q) {

		return angular.extend({
			_searchByEmail : function(email) {
	            var user = null,
	            keys = Object.keys(this._pool),
	            key;

	            for (var i=0, l=keys.length; i<l; i++) {
	                if (this._pool[keys[i]].email.toLowerCase() === email.toLowerCase()) {
	                    user = this._pool[keys[i]];
	                    break;
	                }
	            }
	            return user;
	        },
	        /**Use this function in order to search for a user by its email, must be extended maybe sometime*/
	        searchUserByEmail: function(email) {
	            var deferred = $q.defer(),
	            scope = this,
	            user = this._searchByEmail(email); //FIRST search if user not already loaded in collection
	            
	            if (user){
	                deferred.resolve(user);
	            }
	            else {
	                httpAuth.get('/api/users/page/1?email='+email)
	                .success(function(usersArray) {
	                    var users = []; 
	                    usersArray.docs.forEach(function(userData) {
	                        console.log(userData);
	                        var user = scope._retrieveInstance(userData._id, userData);
	                        users.push(user);
	                    });
	                    deferred.resolve(users[0]);
	                })
	                .error(function(err) {
	                    deferred.reject(err);
	                });
	            }

	            return deferred.promise;
	        },

	        getAllUsers: function(page, filters) {
	            var deferred = $q.defer(),
	            scope = this,
	            queryString = '',
	            QUESTION_MARK = '?',
	            EQUAL = '=',
	            AMPERSAND = '&';

	            if (filters) {
	                var filtersArray = Object.keys(filters), key;

	                for (var i=0, l = filtersArray.length; i<l; i++) {
	                    key = filtersArray[i];
	                    queryString += ((i !== 0) ? AMPERSAND : '') + key + EQUAL + filters[key];
	                }
	                queryString = QUESTION_MARK + queryString;
	            }
	           
	            httpAuth.get('/api/users/page/'+page + queryString)
	                .success(function(usersArray) {
	                    console.log(usersArray.docs);
	                    var users = [], 
	                    toBeResolved = {};
	                    usersArray.docs.forEach(function(userData) {
	                        console.log(userData);
	                        var user = scope._retrieveInstance(userData._id, userData);
	                        users.push(user);
	                    });

	                    toBeResolved.collection = users;
	                    toBeResolved.pages = usersArray.totalPages;
	                    toBeResolved.total = usersArray.totalDocs;
	                    deferred.resolve(toBeResolved);
	                })
	                .error(function(err) {
	                    deferred.reject(err);
	                });
	            return deferred.promise;
	        }
		}, modelManager.init(User));
  };

})();